function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.0625,
  cy: 8.5625,
  r: 2.1875,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.71875,
  cy: 13.0312,
  r: 1.84375,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.375,
  cy: 16.8125,
  r: 1.5,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.03125,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.6875,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.125,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.0625,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.9375,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.875,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.8125,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.75,
  cy: 22.3125,
  r: 0.8125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.7812,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.0312,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.2812,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.53125,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.78125,
  cy: 19.9062,
  r: 1.15625,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.4375,
  cy: 16.8125,
  r: 1.5,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 16.8125,
  r: 1.5,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.25,
  cy: 16.8125,
  r: 1.5,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.8125,
  cy: 16.8125,
  r: 1.5,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.0938,
  cy: 13.0312,
  r: 1.84375,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.9688,
  cy: 13.0312,
  r: 1.84375,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.84375,
  cy: 13.0312,
  r: 1.84375,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5625,
  cy: 8.5625,
  r: 2.1875,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.75,
  cy: 8.5625,
  r: 2.1875,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.4062,
  cy: 3.40625,
  r: 2.53125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.40625,
  cy: 3.40625,
  r: 2.53125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.90625,
  cy: 3.40625,
  r: 2.53125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

function SvgDoTham(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoTham);
export default __webpack_public_path__ + "static/media/DoTham.5b66590e.svg";
export { ForwardRef as ReactComponent };